<template>
  <div
    tabindex="0"
    class="interaction-head display-minimum file-viewer file-viewer-display-minimum mb-0"
    :class="enabledFeatures.includes('hotspotStyling') ? '' : 'pt-2 px-2'"
    :aria-label="`Interaction text: ${localInteraction.interactionText.stripHTML(['img', 'Image'], ['input', 'Input blank'])}`"
  >
    <v-layout
      justify-center
      align-center
      class="mb-1"
    >
      <a
        :href="localInteraction.interactionText"
        target="_blank"
      >
        {{ localInteraction.interactionText }}
      </a>
    </v-layout>

    <!-- Preview iframe of hosted PDF file: -->
    <div
      v-if="showFilePreview"
      id="interaction-head-file-viewer-embedded-display-minimumadobe-viewer-sdk"
      class="interaction-head-file-viewer-embedded-display-minimum-adobe-viewer-sdk-wrapper mb-2"
    >
      <div
        :id="pdfViewerIdentifier"
      >
        <!-- Inject PDF file to preview here! -->
      </div>
    </div>
    
  </div>
</template>

<script>

import Interaction from '../../../mixins/Interaction';
import PdfViewer from '@mixins/PdfViewer/PdfViewer.js';

import uuid from 'uuid';

// Custom Helpers:
import { waitForElementToDisplay } from '@utilities';


export default {
  name: 'FileViewerDisplayMinimumInteractionHead',
  mixins: [
    Interaction,
    PdfViewer,
  ],
  data() {
    return {
      showFilePreview: false,
      viewerId: uuid(),
    }
  },
  props: {
    perspectiveKey: {
      type: String,
      required: true,
    },
    interactionBodyComponentKey: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: false,
    }
  },
  computed: {
    pdfViewerIdentifier() {
      return `interaction-head-display-minimum-file-viewer-pdf-preview-${this.viewerId}`;
    }
  },
  methods: {
    async previewPDF() {
      if (!this?.localInteraction?.interactionText) return;

      this.showFilePreview = true;
      await this.$nextTick();
      const pdfPreviewDivElement = await waitForElementToDisplay(`#interaction-head-display-minimum-file-viewer-pdf-preview-${this.viewerId}`);
      if (!pdfPreviewDivElement) return;

      this.createAdobeViewerInstance({
        divId: `interaction-head-display-minimum-file-viewer-pdf-preview-${this.viewerId}`,
      });
      await this.previewFile({
        resourceLocationUrl: this.localInteraction.interactionText,
      });
    },
  },
  watch: {
    async adobeViewerSDKScriptInjected(newValue, oldValue) { // eslint-disable-line
      if (newValue) {
        await this.previewPDF();
      }
    }
  },
};
</script>

<style lang="scss" scoped>

div[id^="interaction-head-display-minimum-file-viewer-pdf-preview-"] {
  height: 100vh;
  ::v-deep iframe {
    pointer-events: auto;
  }
}

</style>
